import clsx from "clsx";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useAppSelector } from "store";
import { LiveChatWidget } from "@livechat/widget-react";
import useBreakpoint from "hooks/useBreakpoint";

const Tabbar = () => {
  const { user, appGlobal } = useAppSelector((state) => state.app) as any;
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const breakpoint = useBreakpoint();
  const [visible, setVisible] = useState<"maximized" | "minimized" | "hidden">(
    "hidden"
  );

  return (
    <>
      {/* <LiveChatWidget
        license={"18557844"}
        visibility={visible}
        onVisibilityChanged={({ visibility }) => setVisible(visibility)}
      /> */}

      <div className="fixed bottom-[70px] right-[30px] z-[999] flex flex-col gap-2">
        <div className="css-ndk2" style={{ marginBottom: 0 }}>
          <a href="https://t.me/EXSINGS" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full h-full">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM16.82 8.84L14.96 17.61C14.82 18.23 14.45 18.38 13.93 18.09L11.1 16L9.73 17.32C9.58 17.47 9.45 17.6 9.17 17.6L9.37 14.73L14.6 10C14.83 9.79 14.55 9.67 14.24 9.88L7.77 13.95L5 13.08C4.4 12.89 4.39 12.48 5.13 12.19L15.96 8.01C16.46 7.83 16.9 8.13 16.82 8.84Z" fill="#0088cc"/>
            </svg>
          </a>
        </div>
        <div className="css-ndk2" style={{ marginBottom: 0,display:'none' }}>
          <a href="https://www.facebook.com/advisemitrade/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center w-full h-full">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 16.9913 5.65685 21.1283 10.4375 21.8785V14.8906H7.89844V12H10.4375V9.79688C10.4375 7.29063 11.9219 5.90625 14.2047 5.90625C15.2973 5.90625 16.4375 6.10156 16.4375 6.10156V8.5625H15.1766C13.9332 8.5625 13.5469 9.33396 13.5469 10.125V12H16.3203L15.877 14.8906H13.5469V21.8785C18.3431 21.1283 22 16.9913 22 12Z" fill="#1877f2"/>
            </svg>
          </a>
        </div>
      </div>

      <div data-micro-type="Tabbar" className="micro micro-dark">
        <div data-v-ba5e20f0="" className="micro-tabbar min-h-56px md:hidden">
          <div
            data-v-ba5e20f0=""
            className="fixed left-0 z-1 flex py-5px w-full h-56px bg-bgPrimary transition-bottom duration-500"
            style={{
              bottom: 0,
              boxShadow: "rgba(255, 255, 255, 0.03) 0px -0.5px 7px 2px",
              zIndex: 100,
            }}
          >
            <Link
              data-v-ba5e20f0=""
              className="flex flex-col flex-1 justify-center items-center text-contentTertiary text-12px no-underline cursor-pointer"
              to="/"
            >
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={clsx("mb-2px ", {
                  "text-contentPrimary": pathname === "/",
                })}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.38322 9.61722C3.14131 9.80677 3 10.097 3 10.4043V20.4996C3 20.7757 3.22386 20.9996 3.5 20.9996H20.5C20.7761 20.9996 21 20.7757 21 20.4996V10.4043C21 10.097 20.8587 9.80677 20.6168 9.61722L12.3084 3.10692C12.1273 2.96501 11.8727 2.96501 11.6916 3.10692L3.38322 9.61722ZM11.3 12.9395C11.1343 12.9395 11 13.0738 11 13.2395V17.6395C11 17.8052 11.1343 17.9395 11.3 17.9395H12.7C12.8657 17.9395 13 17.8052 13 17.6395V13.2395C13 13.0738 12.8657 12.9395 12.7 12.9395H11.3Z"
                  fill="currentColor"
                />
              </svg>{" "}
              <span
                className={clsx("", {
                  "text-contentPrimary": pathname === "/",
                })}
              >
                {t("Trang chủ")}
              </span>
            </Link>
            <Link
              data-v-ba5e20f0=""
              className="flex flex-col flex-1 justify-center items-center text-contentTertiary text-12px no-underline cursor-pointer"
              to="/market"
            >
              <svg
                width={25}
                height={24}
                viewBox="0 0 25 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={clsx("mb-2px ", {
                  "text-contentPrimary": pathname === "/market",
                })}
              >
                <rect
                  x="10.5"
                  y={3}
                  width={4}
                  height={18}
                  rx="0.5"
                  fill="currentColor"
                />
                <rect
                  x="3.5"
                  y={9}
                  width={4}
                  height={12}
                  rx="0.5"
                  fill="currentColor"
                />
                <rect
                  x="17.5"
                  y={12}
                  width={4}
                  height={9}
                  rx="0.5"
                  fill="currentColor"
                />
              </svg>{" "}
              <span
                className={clsx("", {
                  "text-contentPrimary": pathname === "/market",
                })}
              >
                {t("Thị trường")}
              </span>
            </Link>
            <Link
              data-v-ba5e20f0=""
              className="flex flex-col flex-1 justify-center items-center text-contentTertiary  text-12px no-underline cursor-pointer"
              to="/trading?spot=BTC"
            >
              <img
                src={appGlobal?.LOGO_APP?.value}
                alt=""
                className="w-[35px] mt-[-10px] mb-[5px]"
              />
              <span
                className={clsx("", {
                  "text-contentPrimary": pathname === "/trading",
                })}
              >
                {" "}
                {t("Giao dịch")}
              </span>
            </Link>
            <Link
              data-v-ba5e20f0=""
              className="flex flex-col flex-1 justify-center items-center text-contentTertiary text-12px no-underline cursor-pointer"
              to="/trading-future?symbol=BTC"
            >
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={clsx("mb-2px ", {
                  "text-contentPrimary": pathname === "/trading-future",
                })}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M8 3.5C8 3.22386 8.22386 3 8.5 3H20.5C20.7761 3 21 3.22386 21 3.5V20.5C21 20.7761 20.7761 21 20.5 21H8.5C8.22386 21 8 20.7761 8 20.5V3.5ZM10 6.3C10 6.13431 10.1343 6 10.3 6H18.7C18.8657 6 19 6.13431 19 6.3V7.7C19 7.86569 18.8657 8 18.7 8H10.3C10.1343 8 10 7.86569 10 7.7V6.3ZM10.3 10C10.1343 10 10 10.1343 10 10.3V11.7C10 11.8657 10.1343 12 10.3 12H13.7C13.8657 12 14 11.8657 14 11.7V10.3C14 10.1343 13.8657 10 13.7 10H10.3Z"
                  fill="currentColor"
                />
                <path
                  d="M3 13.5C3 13.2239 3.22386 13 3.5 13H12V21H7C4.79086 21 3 19.2091 3 17V13.5Z"
                  fill="currentColor"
                />
              </svg>{" "}
              <span
                className={clsx("", {
                  "text-contentPrimary": pathname === "/trading",
                })}
              >
                {" "}
                Future
              </span>
            </Link>
            <Link
              to="/invest"
              className="flex flex-col flex-1 justify-center items-center text-contentTertiary text-12px no-underline cursor-pointer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-6 mb-2"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
                />
              </svg>

              <span
                className={clsx("", {
                  "text-contentPrimary": pathname === "/trading",
                })}
              >
                {" "}
                {t("Đầu tư")}
              </span>
            </Link>
            <Link
              data-v-ba5e20f0=""
              className="flex flex-col flex-1 justify-center items-center text-contentTertiary text-12px no-underline cursor-pointer"
              to={user ? "/asset" : "/login"}
            >
              <svg
                width={24}
                height={24}
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={clsx("mb-2px ", {
                  "text-contentPrimary": pathname === "/asset",
                })}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.5 7C3.22386 7 3 7.22386 3 7.5V19.5C3 19.7761 3.22386 20 3.5 20H20.5C20.7761 20 21 19.7761 21 19.5V7.5C21 7.22386 20.7761 7 20.5 7H3.5ZM14.3536 12.6464C14.1583 12.8417 14.1583 13.1583 14.3536 13.3536L15.6464 14.6464C15.8417 14.8417 16.1583 14.8417 16.3536 14.6464L17.6464 13.3536C17.8417 13.1583 17.8417 12.8417 17.6464 12.6464L16.3536 11.3536C16.1583 11.1583 15.8417 11.1583 15.6464 11.3536L14.3536 12.6464Z"
                  fill="currentColor"
                />
                <rect
                  x={3}
                  y={4}
                  width={2}
                  height={5}
                  rx="0.5"
                  fill="currentColor"
                />
                <path
                  d="M4.5 6C4.22386 6 4 5.77614 4 5.5L4 4.5C4 4.22386 4.22386 4 4.5 4L17.5 4C17.7761 4 18 4.22386 18 4.5L18 5.5C18 5.77614 17.7761 6 17.5 6L4.5 6Z"
                  fill="currentColor"
                />
              </svg>{" "}
              <span
                className={clsx("", {
                  "text-contentPrimary": pathname === "/asset",
                })}
              >
                {t("Tài sản")}
              </span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tabbar;
